import { Grid } from "@mui/material"
import { useContext, useState } from "react";
import SAndPComparisonTab from "../Profile/IULProfileTabs/SAndPComparisonTab/SAndPComparisonTab";
import AnnuityAccValueTab from "../Profile/AnnuityProfileTabs/AnnuityAccValueTab";
import AnnuityFeesTab from "../Profile/AnnuityProfileTabs/AnnuityFeesTab";
import { ProfileContext, ProfileContextPayload } from "../../Context/ProfileDetailsContext";
import GlobalTabsComponent from "../../GlobalComponent/GlobalTabsComponent/GlobalTabsComponent";

const AccumulationOutput = () => {
    const [tabNavigationvalue, setTabNavigationValue] = useState<string>('1');

    const {
        accumulationPlanData
    } = useContext(ProfileContext) as ProfileContextPayload

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabNavigationValue(newValue);
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12}
                    sx={{
                        backgroundColor: "#fff",
                        padding: "0px 20px",
                        borderBottom: "1px solid #E2E8F0"
                    }}
                >
                    <GlobalTabsComponent
                        value={tabNavigationvalue || '1'}
                        onChange={handleTabChange}
                        normalColor="#45556C"
                        selectedColor="#04385D"
                        indicatorColor="#04385D"
                        tabs={[
                            { label: "S&P Comparison", value: "1" },
                            { label: "Account Value", value: "2" },
                            { label: "Fees", value: "3" },
                        ]}
                    />
                </Grid>
                <Grid item xs={12} padding={"20px"}>
                    {
                        tabNavigationvalue == "1" && <SAndPComparisonTab />
                    }
                    {
                        tabNavigationvalue == "2" && <AnnuityAccValueTab accumulationPlanData={accumulationPlanData} />
                    }
                    {
                        tabNavigationvalue == "3" && <AnnuityFeesTab />
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default AccumulationOutput